module.exports = __webpack_public_path__ + "static/media/photo.85c097d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/photo.jpg
// module id = 348
// module chunks = 0